// extracted by mini-css-extract-plugin
export var card = "_79-1";
export var container = "_79-0";